<template>
  <el-dialog
    :title="!dataForm.id ? 'Add Office Address' : 'Edit Office Address'"
    :close-on-click-modal="false"
    :visible.sync="visible"
    width="900px"
    top="3vh"
  >
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="140px">
      <el-form-item label="Entity type" prop="type">
        <el-select style="width: 100%" v-model="dataForm.type" placeholder="Select type">
          <el-option v-for="item in entityTypes" :key="item.value" :label="item.title" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Country" prop="country">
        <el-select style="width: 100%" v-model="dataForm.country" placeholder="Select Country">
          <el-option v-for="item in countryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="!isMultiLineAddressCountry" label="Address" prop="address">
        <el-input
          v-model="dataForm.address"
          type="textarea"
          :rows="5"
          :autosize="{ minRows: 4 }"
          resize="none"
          placeholder="Address"
          v-regexFilter="halfWidthRegex"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="isMultiLineAddressCountry" label="Address Line1" prop="addressLine1">
        <el-input v-model="dataForm.addressLine1" placeholder="Address Line1" v-regexFilter="halfWidthRegex"></el-input>
      </el-form-item>
      <el-form-item v-if="isMultiLineAddressCountry" label="Address Line2" prop="addressLine2">
        <el-input v-model="dataForm.addressLine2" placeholder="Address Line2" v-regexFilter="halfWidthRegex"></el-input>
      </el-form-item>
      <el-form-item v-if="isMultiLineAddressCountry" label="Address Line3" prop="addressLine3">
        <el-input v-model="dataForm.addressLine3" placeholder="Address Line3" v-regexFilter="halfWidthRegex"></el-input>
      </el-form-item>
      <el-form-item v-if="isMultiLineAddressCountry" label="State" prop="state">
        <el-select style="width: 100%" v-model="dataForm.state" placeholder="Select State">
          <el-option v-for="item in stateOptions" :key="item.value" :label="item.title" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="City" prop="city">
        <el-input v-model="dataForm.city" placeholder="City" v-regexFilter="halfWidthRegex"></el-input>
      </el-form-item>
      <el-form-item label="PostalCode" prop="postalCode">
        <el-input v-model="dataForm.postalCode" placeholder="postalCode" v-regexFilter="halfWidthRegex"></el-input>
      </el-form-item>
      <el-form-item label="Supplier" prop="supplierId">
        <el-select v-model="dataForm.supplierId" filterable clearable class="wdb100">
          <el-option v-for="item in supplierList" :key="`supplier-${item.id}`" :label="item.companyName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Status" prop="status">
        <el-radio-group v-model="dataForm.status">
          <el-radio :label="0">Disable</el-radio>
          <el-radio :label="1">Enable</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">Submit</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: {
    supplierList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      dataForm: {
        id: 0,
        type: "",
        country: "",
        city: "",
        address: "",
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        state: "",
        postalCode: "",
        supplierId: null,
        status: 1,
      },
      dataRule: {
        type: [{ required: true, message: "please select", trigger: "submit" }],
        country: [{ required: true, message: "please select", trigger: "submit" }],
        city: [{ required: true, message: "please enter", trigger: "submit" }],
        address: [{ required: true, message: "please enter", trigger: "submit" }],
        addressLine1: [{ required: true, message: "please enter", trigger: "submit" }],
        state: [{ required: true, message: "please select", trigger: "submit" }],
        supplierId: [{ required: true, message: "please select", trigger: "submit" }],
      },
      submitLoading: false,
    };
  },
  computed: {
    ...mapState("constant", ["countryList", "entityTypes"]),
    ...mapGetters("constant", ["byCountryFormatList"]),
    // 是否为多行地址国家：隐藏原 Address 文本域，显示 3 个 addressLine 字段
    isMultiLineAddressCountry() {
      const SUPPORTED = ["Malaysia"]; // 后期可新增 "Virgin Islands, British", "Cayman Islands"
      return SUPPORTED.includes(this.dataForm.country);
    },
    // 省/州选项
    stateOptions() {
      return this.byCountryFormatList("provinceOrStateData", "Malaysia");
    },
  },
  methods: {
    // 初始化
    async init(data) {
      this.submitLoading = false;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      if (data) {
        this.dataForm = {
          id: data.id,
          type: data.type,
          country: data.country,
          city: data.city,
          address: data.address,
          addressLine1: data.addressLine1 || "",
          addressLine2: data.addressLine2 || "",
          addressLine3: data.addressLine3 || "",
          state: data.state || "",
          postalCode: data.postalCode,
          supplierId: data.supplier?.id,
          status: data.status,
        };
      } else {
        this.$set(this.dataForm, "id", null);
      }
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .post(
              this.dataForm.id ? `/admin/stRegisteredOfficeAddressManage/${this.dataForm.id}/update` : `/admin/stRegisteredOfficeAddressManage/create`,
              this.dataForm,
            )
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
